import { nullSafeToString, toDisplayPrice } from '../lib/util';

/**
 * A post-order adjustment to the balance of a terms (invoiced) {@link Order Order}.
 *
 * A credit reads as a negative adjustmentAmount. These are what make an order's
 * `adjustedTotals` differ from the totals it was submitted with, so a receipt that shows a
 * terms order's current balance should read the adjusted totals rather than summing these.
 *
 * @property {number} id - (Read only) This adjustment's unique id.
 * @property {number} adjustmentAmount - (Read only) The amount applied. Negative for a credit.
 * @property {string} displayAdjustmentAmount - (Read only) this.adjustmentAmount formatted with commas and two decimal places.
 * @property {string} reason - (Read only) Why the adjustment was made.
 * @property {number} sequence - (Read only) Where this adjustment falls in the order they were applied.
 */

class OrderTermsAdjustment {
    constructor (data = {}) {
        this.id = data.id;
        this.adjustmentAmount = data.adjustmentAmount || 0;
        this.displayAdjustmentAmount = toDisplayPrice(this.adjustmentAmount);
        this.reason = nullSafeToString(data.reason);
        this.sequence = data.sequence || 0;

        Object.freeze(this);
    }
}

export default OrderTermsAdjustment;
